import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { CardsPage } from "@/features/cards/pages/cards-page";
import { cardsFilterSchema } from "@/features/cards/schemas/cards-filter-schema";

export const Route = createFileRoute("/_authenticated/admin/charging/cards/")({
	head: () => pageTitle("Charging cards"),
	component: CardsPage,
	validateSearch: zodValidator(cardsFilterSchema),
});
